import { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import InputMask from 'react-input-mask';
import { useReCaptcha } from "next-recaptcha-v3";
import { fetchPostEmailSendContact, fetchGetCompanySubsidiaries } from "../../../services/api";

export default function ContactUsContactForm({ company }) {
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '', isSuccess: false });
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const onSubmit = async data => {
        const token = await executeRecaptcha("contactSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendContact({
            cellPhone: data.txtCellPhone,
            email: data.txtEmail,
            message: data.txtMessage,
            name: data.txtName,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtName', '');
                    setValue('txtEmail', '');
                    setValue('txtCellPhone', '');
                    setValue('txtMessage', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }

    const [subsidiaries, setSubsidiaries] = useState([])

    useEffect(() => {
        fetchGetCompanySubsidiaries()
            .then(res => {
                const subs = res.map(item => ({
                    city: item.addressCity,
                    federativeUnit: item.addressFederativeUnit,
                    postalCode: item.addressPostalCode,
                    address: item.addressStreet,
                    phone: item.phone,
                    phone2: item.phone2,
                    whatsapp: item.whatsapp,
                    whatsapp2:item.whatsapp2
                }))
                setSubsidiaries(subs)
            })
    }, [])

    return (
        <section className="contact-section ptb-40">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8">
                        <div className="contact-form-area bg-white rounded iv_sidebar_widget iv_seller_widget widget-padding">
                            <h4 className="mb-3">Entre em Contato</h4>
                            <p className="mb-4">Caso tenha alguma dúvida, agendamento de uma visita ou test-drive preencha o formulário. Retornaremos o mais breve possível.</p>
                            <form onSubmit={handleSubmit(onSubmit)} className="ct-form-wrapper">
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="input-field">
                                            <label>Nome</label>
                                            <input type="text" placeholder="Nome Completo" {...register("txtName", { required: true })} required={errors.txtName} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-field">
                                            <label>Email</label>
                                            <input type="email" placeholder="Email" {...register("txtEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtEmail} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-field">
                                            <label>Celular</label>
                                            <InputMask type={'tel'} mask="(99) 99999-9999" maskChar=" " placeholder="Celular" {...register("txtCellPhone", { required: true })} required={errors.txtCellPhone} />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="input-field">
                                            <label>Mensagem</label>
                                            <textarea placeholder="Mensagem" rows="5" {...register("txtMessage", { required: true })} required={errors.txtMessage}></textarea>
                                        </div>
                                    </div>
                                </div>
                                {
                                    formPost.isError
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="error-badge bg-primary-light rounded d-block">{formPost.errorText}</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    formPost.isSuccess
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="success-badge bg-primary-success rounded d-block">Contato enviado com sucesso, aguarde o retorno de nossa equipe!</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                <button className="btn btn-primary-contact btn-md mt-4" disabled={formPost.isLoading} type="submit">Enviar Mensagem</button>
                            </form>
                        </div>
                    </div>
                    <div className="col-xl-4">
                        <div className="contact-sidebar-widget py-5 px-4 bg-white rounded mt-5 mt-xl-0">
                            <h4 className="mb-4">Contatos</h4>
                            <ul className="fs-md">
                                <li className="fw-500"><strong className="fw-bold text-secondary">Endereço{subsidiaries.length > 0? " Matriz:" : ":"} </strong>{`${company.address} - ${company.city} - ${company.federativeUnit} - ${company.postalCode}`}</li>
                                {subsidiaries.length > 0 && subsidiaries.map((item, index) => (
                                <li key={index} className="fw-500"><strong className="fw-bold text-secondary">Endereço Filial {index + 1}: </strong>{`${item.address} - ${item.city} - ${item.federativeUnit} - ${item.postalCode}`}</li>

                                ))}
                            </ul>
                            <hr className="mt-4 mb-4" />
                            <ul className="contact-info">
                                <li className="d-flex flex-direction-column align-items-start">
                                    <div className="d-flex" style={{marginTop: "30px"}}>
                                        <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-solid fa-phone"></i></span>
                                        <div className="ms-3 info-content">
                                            <span className="d-block">{company.phone2 ? company.phone2.length === 10? "Telefone Principal:" : company.phone2.length === 11? "Telefone Principal:" : "Telefone:" : "Telefone:"}</span>
                                            <a href={`tel:+55${company.phone}`}>
                                                {company.phone?
                                                    company.phone.length === 10
                                                        ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 6)}-${company.phone.substring(6, 10)}`
                                                        : company.phone.length === 11
                                                            ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 7)}-${company.phone.substring(7, 11)}`
                                                            : company.phone
                                                :null}
                                            </a>
                                        </div>
                                    </div>

                                    {company.phone2 ?
                                    company.phone2.length === 10 ?
                                    <div className="d-flex" style={{marginTop: "30px"}}>
                                        <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-solid fa-phone"></i></span>
                                        <div className="ms-3 info-content">
                                            <span className="d-block">Telefone Alternativo:</span>
                                            <a href={`tel:+55${company.phone2}`}>
                                                {
                                                    company.phone2.length === 10
                                                        ? `(${company.phone2.substring(0, 2)}) ${company.phone2.substring(2, 6)}-${company.phone2.substring(6, 10)}`
                                                        : company.phone2.length === 11
                                                            ? `(${company.phone2.substring(0, 2)}) ${company.phone2.substring(2, 7)}-${company.phone2.substring(7, 11)}`
                                                            : company.phone2
                                                }
                                            </a>
                                        </div>
                                    </div>
                                    : company.phone2.length === 11?
                                    <div className="d-flex" style={{marginTop: "30px"}}>
                                        <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-solid fa-phone"></i></span>
                                        <div className="ms-3 info-content">
                                            <span className="d-block">Telefone Alternativo:</span>
                                            <a href={`tel:+55${company.phone2}`}>
                                                {
                                                    company.phone2.length === 10
                                                        ? `(${company.phone2.substring(0, 2)}) ${company.phone2.substring(2, 6)}-${company.phone2.substring(6, 10)}`
                                                        : company.phone2.length === 11
                                                            ? `(${company.phone2.substring(0, 2)}) ${company.phone2.substring(2, 7)}-${company.phone2.substring(7, 11)}`
                                                            : company.phone2
                                                }
                                            </a>
                                        </div>
                                    </div>
                                    : null
                                    :null
                                    }

                                {subsidiaries.map((item, index) => (
                                    <div key={index} className={`d-flex ${item.phone.length> 0? null : "d-none"}`} style={{marginTop: "30px"}}>
                                        <span className={`icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0 ${item.phone.length> 0? null : "d-none"}`}><i className="fa-solid fa-phone"></i></span>
                                        <div className="ms-3 info-content">
                                            <span className={`d-block ${item.phone.length> 0? null : "d-none"}`}>Telefone {item.phone2? " Principal " : null} Filial {index + 1}:</span>
                                            <a href={`tel:+55${item.phone}`}>
                                                {
                                                    item.phone.length === 10
                                                        ? `(${item.phone.substring(0, 2)}) ${item.phone.substring(2, 6)}-${item.phone.substring(6, 10)}`
                                                        : item.phone.length === 11
                                                            ? `(${item.phone.substring(0, 2)}) ${item.phone.substring(2, 7)}-${item.phone.substring(7, 11)}`
                                                            : item.phone
                                                }
                                            </a>
                                        </div>
                                    </div>
                                ))}

                                {subsidiaries.length> 0 && subsidiaries.map((item, index) => (
                                    <div key={index} className={`d-flex ${item.phone2.length> 0? null : "d-none"}`} style={{marginTop: "30px"}}>
                                        <span className={`icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0 ${item.phone.length> 0? null : "d-none"}`}><i className="fa-solid fa-phone"></i></span>
                                        <div className="ms-3 info-content">
                                            <span className={`d-block ${item.phone2.length> 0? null : "d-none"}`}>Telefone {item.phone2? " Alternativo " : null} Filial {index + 1}:</span>
                                            <a href={`tel:+55${item.phone2}`}>
                                                {
                                                    item.phone2.length === 10
                                                        ? `(${item.phone2.substring(0, 2)}) ${item.phone2.substring(2, 6)}-${item.phone2.substring(6, 10)}`
                                                        : item.phone2.length === 11
                                                            ? `(${item.phone2.substring(0, 2)}) ${item.phone2.substring(2, 7)}-${item.phone2.substring(7, 11)}`
                                                            : item.phone2
                                                }
                                            </a>
                                        </div>
                                    </div>
                                ))}

                                    </li>
                                    <li className="d-flex align-items-center">
                                    <div className="d-flex flex-direction-column">
                                    <div className="d-flex">
                                        <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-brands fa-whatsapp"></i></span>
                                        <div className="ms-3 info-content">
                                            <span className="d-block">{company.whatsapp2 ? company.whatsapp2.length === 10? "Whatsapp Principal:" : company.whatsapp2.length === 11? "Whatsapp Principal:" : "Whatsapp:" : "Whatsapp:"}</span>
                                            <a target="blank" href={`https://api.whatsapp.com/send?phone=${company.whatsapp}&text=${company.whatsappDefaultMessage ? company.whatsappDefaultMessage : "Olá, gostaria de tirar algumas dúvidas com um consultor. Alguém disponível para me atender agora?"}`}>
                                                { company.whatsapp ? 
                                                    company.whatsapp.length === 10
                                                        ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 6)}-${company.whatsapp.substring(6, 10)}`
                                                        : company.whatsapp.length === 11
                                                            ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 7)}-${company.whatsapp.substring(7, 11)}`
                                                            : company.whatsapp
                                                
                                                :null        }
                                            </a>
                                        </div>
                                    </div>

                                    { company.whatsapp2 ?
                                    company.whatsapp2.length === 10 ?
                                    <div className="d-flex" style={{marginTop: "30px"}}>
                                        <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-brands fa-whatsapp"></i></span>
                                        <div className="ms-3 info-content">
                                            <span className="d-block">Whatsapp Alternativo:</span>
                                            <a target="blank" href={`https://api.whatsapp.com/send?phone=${company.whatsapp2}&text=${company.whatsappDefaultMessage ? company.whatsappDefaultMessage : "Olá, gostaria de tirar algumas dúvidas com um consultor. Alguém disponível para me atender agora?"}`}>
                                                {
                                                    company.whatsapp2.length === 10
                                                        ? `(${company.whatsapp2.substring(0, 2)}) ${company.whatsapp2.substring(2, 6)}-${company.whatsapp2.substring(6, 10)}`
                                                        : company.whatsapp2.length === 11
                                                            ? `(${company.whatsapp2.substring(0, 2)}) ${company.whatsapp2.substring(2, 7)}-${company.whatsapp2.substring(7, 11)}`
                                                            : company.whatsapp2
                                                }
                                            </a>
                                        </div>
                                    </div>
                                    : company.whatsapp2.length === 11?
                                    <div className="d-flex" style={{marginTop: "30px"}}>
                                        <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-brands fa-whatsapp"></i></span>
                                        <div className="ms-3 info-content">
                                            <span className="d-block">Whatsapp Alternativo:</span>
                                            <a target="blank" href={`https://api.whatsapp.com/send?phone=${company.whatsapp2}&text=${company.whatsappDefaultMessage ? company.whatsappDefaultMessage : "Olá, gostaria de tirar algumas dúvidas com um consultor. Alguém disponível para me atender agora?"}`}>
                                                {
                                                    company.whatsapp2.length === 10
                                                        ? `(${company.whatsapp2.substring(0, 2)}) ${company.whatsapp2.substring(2, 6)}-${company.whatsapp2.substring(6, 10)}`
                                                        : company.whatsapp2.length === 11
                                                            ? `(${company.whatsapp2.substring(0, 2)}) ${company.whatsapp2.substring(2, 7)}-${company.whatsapp2.substring(7, 11)}`
                                                            : company.whatsapp2
                                                }
                                            </a>
                                        </div>
                                    </div>
                                    : null
                                    :null
                                    }

                                    </div>
                                </li>
                                <li className="d-flex align-items-center">
                                    <span className="icon-wrapper d-flex align-items-center justify-content-center rounded bg-light-primary rounded-circle flex-shrink-0"><i className="fa-regular fa-envelope"></i></span>
                                    <div className="ms-3 info-content">
                                        <span className="d-block">Email:</span>
                                        <a href={`mailto:${company.email}`}><p>{company.email}</p></a>
                                    </div>
                                </li>
                            </ul>
                            <hr className="mt-30 mb-40" />
                            <h6 className="mb-3">Redes Sociais</h6>
                            <div className="contact-social">
                                {company.instagram ? <a href={company.instagram} target='_blank' rel="noreferrer"><i className="fab fa-instagram"></i></a> : null}
                                {company.facebook ? <a href={company.facebook} target='_blank' rel="noreferrer"><i className="fab fa-facebook-f"></i></a> : null}
                                {company.youtube ? <a href={company.youtube} target='_blank' rel="noreferrer"><i className="fab fa-youtube"></i></a> : null}
                                {company.tiktok ? <a href={company.tiktok} target='_blank' rel="noreferrer"><i className="fab fa-tiktok"></i></a> : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}